<script setup lang="ts">
import { AppBadge } from '../../app-badge'

defineOptions({
  name: 'BadgeNew',
})
</script>

<template>
  <AppBadge
    color="emerald"
    text="New"
  />
</template>
